/**
 * 公共品牌信息 API（前台消费者）
 *
 * 对接 `/api/public/landing/branding` 公开读接口，让登录页与顶栏
 * 展示管理端"基础设置"配置的系统名称与 Logo，不再依赖硬编码文案。
 */
import { httpGet } from '@/utils/httpClient'

export interface PublicBranding {
  systemName: string
  logo: string
  version: number | null
}

export const publicBrandingHttpService = {
  /**
   * 获取公开品牌信息。
   * 公共读接口失败时不向用户抛出技术错误，返回 null 由调用方回退默认品牌名。
   */
  async getBranding(): Promise<PublicBranding | null> {
    try {
      const data = await httpGet<PublicBranding>('/api/public/landing/branding')
      return data ?? null
    } catch (e) {
      console.error('[publicBrandingHttp] failed to load branding:', e)
      return null
    }
  },
}
